import React from 'react';
import PropertyReportTransparency from './PropertyReportTransparency.js';

var PropertyReportTransparencyBlock = {
  Component: function Component(_ref) {
    var attrs = _ref.attrs;
    var id = attrs.id;
    return /*#__PURE__*/React.createElement(PropertyReportTransparency, {
      id: id
    });
  },
  metadata: {
    version: '1.0',
    name: 'constellation/property-report-transparency',
    title: 'Property Report Transparency Component',
    description: 'Property Report Transparency Component',
    icon: 'search',
    keywords: ['property', 'report', 'transparency'],
    supports: {
      customClassName: false,
      html: false
    },
    category: 'Forms',
    attributes: {
      id: {
        type: 'string'
      }
    }
  }
};
var PropertyReportTransparencyBlock$1 = PropertyReportTransparencyBlock;

export { PropertyReportTransparencyBlock$1 as default };
